import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat',
    standalone: false
})
export class PhoneFormatPipe implements PipeTransform {
    transform(phoneNumber: string): string {
        if (!phoneNumber) {
            return '';
        }

        const cleaned = phoneNumber.replace(/\D/g, '');

        if (cleaned.length === 11 && cleaned.charAt(0) === '1') {
            const withoutCountryCode = cleaned.substring(1);
            return `(${withoutCountryCode.substring(0, 3)}) ${withoutCountryCode.substring(3, 6)}-${withoutCountryCode.substring(6)}`;
        }

        if (cleaned.length === 10) {
            return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
        }

        return phoneNumber;
    }
}

